import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInputSelectAccountType = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8.53528,
		cy: 4.62903,
		r: 3.62903,
		stroke: "black",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16 16.0001V14.3065V14.3065C16 12.3023 14.3752 10.6775 12.371 10.6775H4.62903C2.62477 10.6775 1 12.3023 1 14.3065V14.3065V16.0001",
		stroke: "black",
		strokeWidth: 1.5
	})]
});
export default SvgInputSelectAccountType;
